import { AppInstallation } from '@tribeplatform/gql-client/types'
import { useI18n } from '@tribeplatform/react-components/i18n'

import { OAuthSection } from '../../OAuth/components/index.js'
import { defaultOAuthSections } from '../../OAuth/constants.js'
import {
  extractOAuthScopes,
  getOAuthSectionsByScopes,
} from '../../OAuth/utils/utils.js'

type SectionProps = {
  appInstallation: AppInstallation
}
export const ConnectedAppSections = ({ appInstallation }: SectionProps) => {
  const intl = useI18n()

  const installedAppOauthScopes = extractOAuthScopes(
    appInstallation?.permissions ?? [],
  )

  const sections = getOAuthSectionsByScopes(
    defaultOAuthSections(intl),
    installedAppOauthScopes.scopes,
  )

  return (
    <>
      {sections.map(section => (
        <OAuthSection
          key={section.key}
          title={section.getTitle(appInstallation.app.name)}
          subSections={section.subSections}
        />
      ))}
    </>
  )
}
